import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-white/60' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="w-11 h-11 rounded-xl bg-athletic-700 flex items-center justify-center shadow-sm ring-1 ring-athletic-900/10 transition-colors group-hover:bg-athletic-800">
        <span className="font-display font-extrabold text-white text-[15px] tracking-tight leading-none">WSH</span>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-extrabold text-[1.15rem] tracking-tight ${textColor} transition-colors`}>
          Work Supply House
        </span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.24em] mt-1 ${subTextColor} transition-colors`}>
          Office &amp; Workspace
        </span>
      </div>
    </Link>
  );
};

export default Logo;
